import React from 'react';

const squareStyle = (accent, disabled) => ({
    flex: 1,
    aspectRatio: "1 / 1",
    maxWidth: "45vw",
    background: "linear-gradient(160deg, " + accent + " 0%, #2a2d4a 85%)",
    border: "3px solid " + accent,
    borderRadius: "16px",
    boxShadow: "0 6px 18px rgba(0, 0, 0, 0.45), inset 0 1px 0 rgba(255, 255, 255, 0.15)",
    color: "white",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    gap: "10px",
    padding: "12px",
    boxSizing: "border-box",
    cursor: disabled ? "default" : "pointer",
    opacity: disabled ? 0.4 : 1,
    transition: "transform 0.15s ease, box-shadow 0.15s ease",
    fontFamily: "inherit",
    WebkitTapHighlightColor: "transparent"
});

const SquareImage = ({src}) => {
    const [failed, setFailed] = React.useState(false);
    React.useEffect(() => setFailed(false), [src]);
    if (!src || failed) return null;
    return <img style={{width: "45%", height: "auto"}} src={src} alt={" "} onError={() => setFailed(true)}/>;
};

/**
 * Big side by side square buttons, for the few choices that deserve to stand out (e.g. the bonus at 2 conservation
 * points). Each option is {action, label, accent}.
 */
export const SquareChoice = ({title, subtitle, options, setConfirmAction}) => {
    const [pressed, setPressed] = React.useState(-1);
    return <div>
        <h2 style={{textAlign: "center", marginBottom: "4px"}}>
            {title}
        </h2>
        {
            subtitle && <div style={{textAlign: "center", fontSize: "16px", opacity: 0.8, marginBottom: "20px"}}>
                {subtitle}
            </div>
        }
        <div style={{display: "flex", flexDirection: "row", justifyContent: "center", gap: "16px"}}>
            {
                options.map((option, i) =>
                    <button
                        key={option.action.name + i}
                        disabled={!option.action.ok}
                        style={{
                            ...squareStyle(option.accent, !option.action.ok),
                            transform: pressed === i ? "scale(0.95)" : "scale(1)"
                        }}
                        onPointerDown={() => setPressed(i)}
                        onPointerUp={() => setPressed(-1)}
                        onPointerLeave={() => setPressed(-1)}
                        onClick={() => setConfirmAction({action: option.action, message: option.action.name + " ?"})}
                    >
                        <SquareImage src={"/public/arknova/actions/" + (option.action.imageName || "").toLowerCase() + ".png"}/>
                        <div style={{fontSize: "18px", fontWeight: "bold", textAlign: "center", lineHeight: 1.2}}>
                            {option.label}
                        </div>
                    </button>
                )
            }
        </div>
    </div>
};

export default SquareChoice;
